import { createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import {
  apiMemberLogin,
  apiMemberPhoneLogin,
  apiMemberRegister,
  apiUserQueryUserBasic,
  apiUserLogout,
  apiUserUpdateUserBasic,
  apiUserUpdatePassword,
  apiUserQueryVCode
} from '../../../shared/api';
import { history } from '../../routes';

const initialState = {
  currentKey: 1,
  open: false,
  disabled: false,
  vcodeDisabled: false,
  vcodeTime: 60,
  vcodeConfig: {},
  userInfo: {},
  orderArr: []
};

const loginModalSlice = createSlice({
  name: 'loginModal',
  initialState,
  reducers: {
    setCurrentKey(state, action) {
      state.currentKey = action.payload;
    },
    setDisabled(state, action) {
      state.disabled = action.payload;
    },
    setVcodeDisabled(state, action) {
      state.vcodeDisabled = action.payload;
    },
    setVcodeTime(state, action) {
      state.vcodeTime = action.payload;
    },
    setVcodeConfig(state, action) {
      state.vcodeConfig = action.payload;
    },
    setUserInfo(state, action) {
      state.userInfo = action.payload;
    },
    openLoginModal(state) {
      state.currentKey = 1;
      state.open = true;
    },
    openRegisterModal(state) {
      state.currentKey = 2;
      state.open = true;
    },
    closeModal(state) {
      state.open = false;
    },
    setOrderArr(state, action) {
      state.orderArr = action.payload;
    }
  }
});

export const {
  setCurrentKey,
  setDisabled,
  setVcodeDisabled,
  setVcodeTime,
  setVcodeConfig,
  setUserInfo,
  openLoginModal,
  openRegisterModal,
  closeModal,
  setOrderArr
} = loginModalSlice.actions;

/**
 * 查询二维码
 * @returns
 */
export const queryVCode = () => async (dispatch) => {
  const res = await apiUserQueryVCode();
  if (res) {
    dispatch(setVcodeConfig(res));
  }
};

/**
 * 通过密码登录
 * @param {object} formValue
 * @returns
 */
export const loginByPassword = (formValue, vcodeConfig) => async (dispatch) => {
  dispatch(setDisabled(true));
  const res = await apiMemberLogin({
    ...formValue
    // vid: vcodeConfig.vid
  });
  // dispatch(queryVCode());
  if (res && res.token) {
    dispatch(setDisabled(false));
    message.success('登录成功');
    window.location.reload();
    localStorage.setItem('TOKEN', res.token);
    dispatch(getUserInfo());
    return true;
  } else {
    // message.error(res?.msg);
    dispatch(setDisabled(false));
    return false;
  }
};
/**
 * 通过手机号登录
 * @param {object} formValue
 * @returns
 */
export const loginByPhone = (formValue, vcodeConfig) => async (dispatch) => {
  dispatch(setDisabled(true));
  const res = await apiMemberPhoneLogin({ ...formValue, vid: vcodeConfig.vid });
  if (res) {
    dispatch(setDisabled(false));
    message.success('登录成功');
    localStorage.setItem('TOKEN', res.token);
    dispatch(getUserInfo());
    return true;
  }
  dispatch(setDisabled(false));
  return false;
};
/**
 * 注册
 * @param {*} formValue
 * @param {*} vcodeConfig
 * @returns
 */
export const register = (formValue, vcodeConfig) => async (dispatch) => {
  dispatch(setDisabled(true));
  const res = await apiMemberRegister({ ...formValue, vid: vcodeConfig.vid });
  dispatch(queryVCode());

  if (res && res.code) {
    message.error(res.msg);
  } else if (res) {
    dispatch(setDisabled(false));
    dispatch(setCurrentKey(1));
    message.success('注册成功');
    return true;
  }
  dispatch(setDisabled(false));
};
/**
 * 获取用户信息
 * @returns
 */
export const getUserInfo = () => async (dispatch) => {
  if (localStorage.getItem('TOKEN')) {
    const userInfo = await apiUserQueryUserBasic();
    if (userInfo) {
      localStorage.setItem('USER', JSON.stringify(userInfo));
      dispatch(setUserInfo(userInfo));
    }
  }
};

/**
 * 退出登录
 * @returns
 */
export const logout = () => async (dispatch) => {
  const res = await apiUserLogout();
  if (res) {
    localStorage.clear();
    message.success('退出登录成功');
    history.push('/');
    dispatch(setUserInfo({}));
  }
};

export const updateUserBasic = (formValue) => async (dispatch) => {
  const res = await apiUserUpdateUserBasic(formValue);
  if (res) {
    message.success('修改成功');
    dispatch(getUserInfo());
    return true;
  }
  return false;
};
/**
 * 修改密码
 * @param {*} param0
 * @returns
 */
export const updatePassword = ({ oldPassword, newPassword }) => async (dispatch) => {
  const res = await apiUserUpdatePassword({ oldPassword, newPassword });
  if (res) {
    message.success('修改成功');
    dispatch(logout());
    return true;
  }
  return false;
};

export default loginModalSlice.reducer;
